<ng-template #toolbar>
  <div class="ui-helper-clearfix" style="text-align: right">
    <button
      type="button"
      class="btn btn-success mr-1"
      (click)="printPlantingCards()"
      [disabled]="!areTableOperationsEnabled"
    >
      Print Planting Cards
      <ng-container *ngIf="areTableOperationsEnabled">
        for {{ selectedRequests.length }} Request(s)</ng-container
      >
    </button>
  </div>
</ng-template>

<div class="ui-fluid">
  <p-table
    #dt
    [columns]="cols"
    [value]="displayedRequests"
    [totalRecords]="requestCount"
    [loading]="isLoading"
    [lazy]="true"
    (onLazyLoad)="loadRequests($event)"
    [selection]="selectedRequests"
    (selectionChange)="onSelectedRequestsChange($event)"
    [paginator]="true"
    [first]="firstIndexInPage"
    [rows]="numberOfRowsPerPage"
    [rowsPerPageOptions]="[15, 50, 100]"
    (onPage)="onPageChange($event)"
    (onSort)="resetCurrentPage()"
    (onFilter)="resetCurrentPage()"
    sortField="plantDate"
    sortOrder="-1"
    [autoLayout]="true"
    [resizableColumns]="true"
    filterDelay="500"
    virtualScrollDelay="250"
  >
    <ng-template pTemplate="caption">
      <ng-container [ngTemplateOutlet]="toolbar"> </ng-container>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          rowspan="2"
          pResizableColumn
          style="width: 3em; vertical-align: middle"
        >
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          rowspan="2"
          pResizableColumn
          style="width: 3em; vertical-align: middle"
        >
          Actions
        </th>
        <ng-container *ngFor="let col of columns">
          <th
            *ngIf="col.sortable"
            pResizableColumn
            [pSortableColumn]="col.field"
          >
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th *ngIf="!col.sortable" pResizableColumn>
            {{ col.header }}
          </th>
        </ng-container>
      </tr>
      <tr>
        <th
          *ngFor="let col of columns"
          pResizableColumn
          [ngSwitch]="col.field"
          [ngStyle]="{
            'vertical-align': col.field === 'status' ? 'top' : 'baseline'
          }"
        >
          <input
            *ngSwitchCase="'requestNumber'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <input
            *ngSwitchCase="'title'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <p-multiSelect
            *ngSwitchCase="'status'"
            styleClass="ui-column-filter"
            defaultLabel="All"
            [options]="requestStatusDropdownOptions"
            (onChange)="dt.filter($event.value, col.field, 'in')"
            maxSelectedLabels="1"
            selectedItemsLabel="{0} statuses"
            appendTo="body"
          >
          </p-multiSelect>
          <input
            *ngSwitchCase="'requester'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <input
            *ngSwitchCase="'delegate'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <input
            *ngSwitchCase="'tacticalLiaison'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <input
            *ngSwitchCase="'crop'"
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, col.field, 'contains')"
          />
          <p-calendar
            [(ngModel)]="dateRange"
            *ngSwitchCase="'plantDate'"
            selectionMode="range"
            appendTo="body"
            readonlyInput="true"
            showButtonBar="true"
            showIcon="true"
            (onSelect)="dt.filter($event, col.field, 'in')"
            (onClearClick)="dt.filter('', 'date', 'equals')"
          >
          </p-calendar>
          <p-multiSelect
            *ngSwitchCase="'requestPurpose'"
            styleClass="ui-column-filter"
            defaultLabel="All"
            [options]="requestPurposeDropdownOptions"
            (onChange)="dt.filter($event.value, col.field, 'in')"
            maxSelectedLabels="1"
            selectedItemsLabel="{0} statuses"
            appendTo="body"
          >
          </p-multiSelect>
          <p-dropdown
            *ngSwitchCase="'isSamplingRequired'"
            [style]="{ width: '100%' }"
            [options]="yesNoDropdownOptions"
            [showClear]="true"
            (onChange)="dt.filter($event.value, col.field, 'equals')"
            appendTo="body"
          >
          </p-dropdown>
          <p-dropdown
            *ngSwitchCase="'isRecurringRequest'"
            [style]="{ width: '100%' }"
            [options]="yesNoDropdownOptions"
            [showClear]="true"
            (onChange)="dt.filter($event.value, col.field, 'equals')"
            appendTo="body"
          >
          </p-dropdown>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-request let-columns="columns">
      <tr>
        <td>
          <p-tableCheckbox
            *ngIf="allowPlantingCardPrintingForRequest(request)"
            [value]="request"
            [disabled]="!allowPlantingCardPrintingForRequest(request)"
          ></p-tableCheckbox>
        </td>
        <td>
          <a [routerLink]="getViewLink(request.id)" class="fa fa-eye"></a>
          <span *appEnableForRoles="editRoles">
            <a
              [routerLink]="getEditLink(request.id)"
              *ngIf="
                request.statusId === 1 &&
                (request.requesterId === currentUser.id ||
                  request.delegateId === currentUser.id)
              "
              class="fa fa-pencil-square-o"
            >
            </a>
          </span>
        </td>
        <td>{{ request.requestNumber }}</td>
        <td>{{ request.title }}</td>
        <td>{{ request.status }}</td>
        <td>{{ request.requester }}</td>
        <td>{{ request.delegate }}</td>
        <td>{{ request.tacticalLiaison }}</td>
        <td>{{ request.crop }}</td>
        <td>
          <span *ngIf="!request.plantDate"></span>
          <span *ngIf="request.plantDate && request.isActualPlantDate">{{
            request.plantDate | date : "shortDate"
          }}</span>
          <span *ngIf="request.plantDate && !request.isActualPlantDate"
            >({{ request.plantDate | date : "shortDate" }})</span
          >
        </td>
        <td>{{ request.requestPurpose }}</td>
        <td>{{ request.isSamplingRequired | yesNo }}</td>
        <td>{{ request.isRecurringRequest | yesNo }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <ng-container [ngTemplateOutlet]="toolbar"> </ng-container>
    </ng-template>
  </p-table>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-list/request-list.component.html